import * as d3 from 'd3';
import { drawBollingerBandsIndicator } from './findicators/BollingerBands';
import { prepareBollingerBandsData } from './prepIndicator/prepareBollingerBands';
import drawKeltnerChannelsIndicator from './findicators/KeltnerChannels';
import { prepareKeltnerChannelsData } from './prepIndicator/prepareKeltnerChannels';
import { drawParabolicSAR } from './findicators/ParabolicSAR';
import { drawIchimokuCloud } from './findicators/Ichimoku';
import { getIndicatorColor } from './findicators/colors';
import { isValidNumber } from './findicators/isValidNumber';
import { safeGetValue } from './findicators/isSafeValue';

export const drawOverlayIndicators = (svg, data, xScale, yScale, indicators) => {
    try {
        indicators.forEach((indicator) => {
            const { values, type, name } = indicator;

            switch (type) {
                case 'overlay':
                    // Plain single-series line overlays (SMA, EMA).
                    drawLineIndicator(svg, data, xScale, yScale, values, getIndicatorColor(name));
                    break;

                case 'bollinger_bands':
                    if (values?.upper_band && values?.middle_band && values?.lower_band) {
                        const prepared = prepareBollingerBandsData(data, values);
                        drawBollingerBandsIndicator({ svg, data, xScale, yScale, indicators: prepared });
                    } else {
                        console.warn(`Bollinger Bands data missing for: ${name}`);
                    }
                    break;

                case 'keltner_channels':
                    if (values?.upper_band && values?.middle_band && values?.lower_band) {
                        const prepared = prepareKeltnerChannelsData(data, values);
                        drawKeltnerChannelsIndicator({ svg, xScale, yScale, indicators: prepared });
                    } else {
                        console.warn(`Keltner Channels data missing for: ${name}`);
                    }
                    break;

                case 'parabolic_sar':
                    if (Array.isArray(values)) {
                        drawParabolicSAR(svg, data, xScale, yScale, values);
                    } else {
                        console.warn(`Parabolic SAR data missing for: ${name}`);
                    }
                    break;

                case 'ichimoku':
                    if (values && typeof values === 'object') {
                        drawIchimokuCloud(svg, data, xScale, yScale, values);
                    } else {
                        console.warn(`Ichimoku data missing for: ${name}`);
                    }
                    break;

                default:
                    console.warn(`Unhandled overlay indicator type: ${type} (${name})`);
            }
        });
    } catch (error) {
        console.warn('Error in drawOverlayIndicators:', error);
    }
};

const drawLineIndicator = (svg, data, xScale, yScale, key, strokeColor) => {
    try {
        if (Array.isArray(key)) {
            const lineGenerator = d3.line()
                .x((d, i) => xScale(new Date(data[i].start_date)))
                .y((d, i) => yScale(key[i]))
                .curve(d3.curveMonotoneX);

            svg.append('path')
                .datum(key)
                .attr('class', 'indicator-line')
                .attr('fill', 'none')
                .attr('stroke', strokeColor)
                .attr('stroke-width', 1.5)
                .attr('d', lineGenerator);
        } else {
            const validData = data.filter((d) => isValidNumber(d[key]));
            const lineGenerator = d3.line()
                .x((d) => xScale(new Date(d.start_date)))
                .y((d) => yScale(safeGetValue(d, key)))
                .curve(d3.curveMonotoneX);

            svg.append('path')
                .datum(validData)
                .attr('class', `${key}-line`)
                .attr('fill', 'none')
                .attr('stroke', strokeColor)
                .attr('stroke-width', 1.5)
                .attr('d', lineGenerator);
        }
    } catch (error) {
        console.warn(`Error drawing line indicator for ${key}:`, error);
    }
};
